// Деньги — по конвенции проекта: toLocaleString("ru-RU") + « ₽»
export const fmtRub = (n) => `${Math.round(n).toLocaleString("ru-RU")} ₽`;
// Цена в ячейке календаря: «от 5 000» — без ₽, ячейка узкая; знак рубля есть в aria-label ячейки
export const fmtFrom = (n) => `от ${Math.round(n).toLocaleString("ru-RU")}`;
